import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';
import type {
	EventMsg,
	EventType,
	TEvent,
} from '~shared/services/eventsInbox/types';

// TODO: validate event data
export const parseEvent = (data: string): EventMsg | undefined => {
	try {
		const event = JSON.parse(data) as TEvent;
		const type = (event.label || event.type) as EventType;
		const payload = event.payload || event.details;
		// workaround. timestamp in event from ws is incorrect
		if (event.sync && payload.timestamp) {
			payload.timestamp = +event.sync;
		}
		return { type, payload } as EventMsg;
	} catch (error) {
		ClientLogger.error(
			LoggerServices.NetworkService,
			LoggerMessages.WebsocketParseFailed,
			{ error }
		);
	}
};

export const parseWsEvent = (event: TEvent): EventMsg => {
	const type = (event.label || event.type) as EventType;
	const payload = event.payload || event.details || { timestamp: +event.sync };
	return { type, payload } as EventMsg;
};
